module.exports = __webpack_public_path__ + "static/media/s_v10_t1.917ebe34.mp3";